export const RECALL_CONTROL = Object.freeze({
  READONLY: 'READONLY',
  NO_CONTRACT: 'NO_CONTRACT',
  DISABLED: 'DISABLED'
});



// WEBPACK FOOTER //
// ./src/constants/recalls.js